module.exports = __webpack_public_path__ + "static/images/containers/ChallengeView/components/Leaderboard/images/prize-background.deb2605f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengeView/components/Leaderboard/images/prize-background.png
// module id = 2814
// module chunks = 11